module.exports = __webpack_public_path__ + "img/index_banner3.6358087c.jpg";